export function partnerLogo() {
	const logos = document.querySelectorAll('.partner-logo.hidden')

	logos.forEach((logo) => {
		const text = logo.parentElement.querySelector('.yn-article__text')

		if (!text || text.closest('.yn-article__image_text')) return

		// Mirror the markup of the "image_text" article element so the logo
		// sits in its own column next to the text instead of being floated.
		const row = document.createElement('div')
		row.className = 'yn-article__image_text partner-logo-row'

		const wrapper = document.createElement('div')
		wrapper.className = 'yn-article__text-wrapper'

		text.replaceWith(row)
		wrapper.append(text)
		row.append(logo, wrapper)
		logo.classList.remove('hidden')
	})
}
